import React, { useRef, useEffect } from "react";

const storeDisplayed = (id, displayedRef) => {
  displayedRef.current = [...displayedRef.current, id];
};

const isNotificationAlreadyDisplayed = (notificationKey, displayedRef) => {
  return displayedRef.current.includes(notificationKey);
};

const createSnackbarAction = (notification, closeSnackbar) => (key) =>
  (
    <div
      id={`clickable-snackbar-${notification.options.variant}`}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        cursor: "pointer",
        background: "transparent",
        zIndex: 9999,
      }}
      onClick={(e) => {
        e.stopPropagation();
        closeSnackbar(key);
      }}
    />
  );

const processNotification = (
  notification,
  displayedRef,
  enqueueSnackbar,
  removeSnackbar,
  closeSnackbar
) => {
  if (isNotificationAlreadyDisplayed(notification.key, displayedRef)) {
    return;
  }

  const snackbarAction = createSnackbarAction(notification, closeSnackbar);

  enqueueSnackbar(notification.message, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    action: snackbarAction,
    ...notification.options,
  });

  storeDisplayed(notification.key, displayedRef);
  removeSnackbar(notification.key);
};

export const Notifier = ({
  notifications = [],
  enqueueSnackbar,
  removeSnackbar,
  closeSnackbar,
}) => {
  const displayedRef = useRef([]);

  useEffect(() => {
    notifications.forEach((notification) => {
      processNotification(
        notification,
        displayedRef,
        enqueueSnackbar,
        removeSnackbar,
        closeSnackbar
      );
    });
  }, [notifications, enqueueSnackbar, removeSnackbar, closeSnackbar]);

  return null;
};
